/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_4_P2Inputs */



/**
* | output |
* | --- |
* | "The above limitations of liability do not apply to damages from injury to life, body, or health, nor to intent or gross negligence by oneAI or its executive ..." |
*
* @param {Guardrails_Section_4_P2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_4_p2 = /** @type {((inputs?: Guardrails_Section_4_P2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_4_P2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die vorstehenden Haftungsbeschränkungen gelten nicht für Schäden aus der Verletzung von Leben, Körper oder Gesundheit sowie für Vorsatz und grobe Fahrlässigkeit von oneAI oder deren leitenden Angestellten.")
	return /** @type {LocalizedString} */ ("The above limitations of liability do not apply to damages from injury to life, body, or health, nor to intent or gross negligence by oneAI or its executive employees.")
});